/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PayerId/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function PayerId({
  children,
  viewPath = "/DesignSystem/DataVaxiomInsuranceBillingCenter/PayerId",
  isInvalid,
  onChange
  
}) {
let billingCenterPayerIdValueData = fromData.useDataValue({ viewPath,
context: 'billing_center',
path: 'payer_id',
})
let billingCenterPayerIdIsValidData = fromData.useDataIsValid({ viewPath,
context: 'billing_center',
path: 'payer_id',
validate: fromValidate.textInput,
required: true,
})
let billingCenterPayerIdChangeData = fromData.useDataChange({ viewPath,
context: 'billing_center',
path: 'payer_id',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="billing_center.payer_id"
 validate="/Data/validate.js textInput"
 invalid={!billingCenterPayerIdIsValidData}
 required={true}
 value={billingCenterPayerIdValueData}
 onChange={billingCenterPayerIdChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Payor Id"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}